var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAsana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/asana"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6057 22.9116C26.5218 22.9116 23.2113 26.1772 23.2113 30.2058C23.2113 34.2343 26.5218 37.5 30.6057 37.5C34.6895 37.5 38 34.2342 38 30.2058C38 26.1772 34.6895 22.9116 30.6057 22.9116ZM11.3943 22.9122C7.31062 22.9122 4 26.1772 4 30.2058C4 34.2343 7.31062 37.5 11.3943 37.5C15.4783 37.5 18.7891 34.2342 18.7891 30.2058C18.7891 26.1772 15.4783 22.9122 11.3943 22.9122ZM28.3943 13.794C28.3943 17.8225 25.0837 21.0886 21.0001 21.0886C16.9161 21.0886 13.6057 17.8225 13.6057 13.794C13.6057 9.76581 16.916 6.5 21 6.5C25.0836 6.5 28.3941 9.76607 28.3941 13.7938",
    fill: "#F06A6A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAsana);
export default __webpack_public_path__ + "static/media/ic_asana.6ad0dfc09b664712971d72a677e257ae.svg";
export { ForwardRef as ReactComponent };